import React from 'react';
import { darkTheme } from 'design-system/src/styles/Themes';
import VideoPlayerVertical from 'design-system/src/Widget/Player/VideoPlayer/VideoPlayerVertical.web';
import Typography from 'design-system/src/Components/Typography/Typography.web';
import Icon from 'design-system/src/Components/Icon/Icon';
import DiscoverActionButton from 'design-system/src/Widget/Discover/DiscoverActionButton/DiscoverActionButton';
import ShareDialog from 'design-system/src/Components/Dialog/ShareDialog/ShareDialog';
import DateFactory from '@src/tools/DateFactory';

interface AppVideoPlayerVerticalLayoutProps {
  news: any;
  isMobile: boolean;
  viewportHeight?: number;
  videoUrl?: string;
  isLiked: boolean;
  count: number;
  handleOnVideoLoad: (...args: any[]) => void;
  handleOnTimeProgress: (...args: any[]) => void;
  onPlayEnd: () => void;
  onGetDuration: (duration: number) => void;
  onTimeUpdate: (seconds: number) => void;
  onVideoPlay: (isPaused: boolean) => void;
  onVideoPause: () => void;
  simpleToggle: (id: string, value: boolean) => void;
  shareContent: any;
  isOpenDialogShare: boolean;
  setIsOpenDialogShare: (open: boolean) => void;
  t: (key: string) => string;
}

const AppVideoPlayerVerticalLayout: React.FC<AppVideoPlayerVerticalLayoutProps> = ({
  news,
  isMobile,
  viewportHeight,
  videoUrl,
  isLiked,
  count,
  handleOnVideoLoad,
  handleOnTimeProgress,
  onPlayEnd,
  onGetDuration,
  onTimeUpdate,
  onVideoPlay,
  onVideoPause,
  simpleToggle,
  shareContent,
  isOpenDialogShare,
  setIsOpenDialogShare,
  t,
}) => (
  <div
    style={{
      backgroundColor: darkTheme.colors.backgroundBlack,
      width: isMobile ? '100vw' : '100%',
      borderTopLeftRadius: 8,
      borderTopRightRadius: 8,
      backgroundImage: isMobile ? undefined : `url(${news?.thumbnail?.url || ''})`,
      backgroundSize: 'cover',
      position: isMobile ? 'fixed' : 'relative',
      minHeight: '100%',
      height: viewportHeight,
      zIndex: 1000,
    }}
  >
    <div
      style={{
        width: '100%',
        height: '100%',
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
        backdropFilter: 'blur(40px)',
        background:
          'linear-gradient(180deg, rgba(17, 18, 22, 0.00) 15.54%, rgba(17, 18, 22, 0.80) 57.45%, #111216 74.32%)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: isMobile ? '100%' : 430,
          height: '100%',
          padding: !isMobile ? '52px 0' : 0,
        }}
      >
        <div
          style={{
            width: '100%',
            height: '100%',
            position: 'relative',
          }}
        >
          <VideoPlayerVertical
            source={{ uri: videoUrl || '' }}
            title={news?.title || ''}
            borderRadius={isMobile ? 0 : 8}
            poster={news?.thumbnail?.url || ''}
            onVideoLoad={handleOnVideoLoad}
            onTimeProgress={handleOnTimeProgress}
            onPlayEnd={onPlayEnd}
            onGetDuration={onGetDuration}
            onTimeUpdate={onTimeUpdate}
            onVideoPlay={onVideoPlay}
            onVideoPause={onVideoPause}
          />
        </div>
        <div
          style={{
            marginTop: 12,
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            position: isMobile ? 'absolute' : 'relative',
            left: 0,
            bottom: isMobile ? '60px' : 0,
            padding: isMobile ? '0 16px' : 0,
            alignItems: isMobile ? 'flex-end' : 'flex-start',
          }}
        >
          {/* left */}
          <div>
            <Typography variant="h2">{news?.title || ''}</Typography>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginTop: 12,
                gap: 12,
              }}
            >
              <Typography variant="ui3" color={() => darkTheme.colors.fontGray}>
                {(news?.author &&
                  news?.author[0] &&
                  news?.author[0].content &&
                  news?.author[0].content.__typename === 'Author' &&
                  news?.author[0].content.authorName) ||
                  t('Unknown')}
              </Typography>
              <div
                style={{
                  display: 'flex',
                  gap: 6,
                  alignItems: 'center',
                }}
              >
                <Icon name="desktop" size="24" color="white" />
                <Typography variant="ui3" color={() => darkTheme.colors.fontGray}>
                  {new DateFactory(news?.pubDate).format()}
                </Typography>
              </div>
            </div>
          </div>
          {/* right */}
          <div
            style={{
              display: 'flex',
              gap: 18,
              flexDirection: isMobile ? 'column' : 'row',
              height: '100%',
            }}
          >
            <DiscoverActionButton
              style={{ marginBottom: 20 }}
              icon={{ name: isLiked ? 'favoris-fill' : 'favoris' }}
              isLikeType={true}
              isLiked={isLiked}
              onPressFav={value => {
                if (news?.id) {
                  simpleToggle(news.id, value);
                }
              }}
              count={count}
            />
            <DiscoverActionButton
              icon={{ name: 'share' }}
              onPress={() => {
                news &&
                  news.url &&
                  shareContent.share({
                    __typename: news.__typename,
                    url: news.url,
                    message: news.title,
                    id: news.id,
                    category: news.parent?.name,
                    cover: news.thumbnail && news.thumbnail.url ? news.thumbnail.url : '',
                    description: news.shortDescription || '',
                  });
                setIsOpenDialogShare(true);
              }}
            />
          </div>
        </div>
      </div>
    </div>
    <ShareDialog isOpen={isOpenDialogShare} onClose={() => setIsOpenDialogShare(false)} />
  </div>
);

export default AppVideoPlayerVerticalLayout;
